// BrainForge Buy Units Modal
import React, { useState } from 'react';
import { apiUrl } from '../config/api';

const PACKAGES = [
  { id: 'pack10', units: 10, price: '$1.99', priceNum: 1.99, perUnit: '$0.20', label: '10 Rounds' },
  { id: 'pack50', units: 50, price: '$6.99', priceNum: 6.99, perUnit: '$0.14', label: '50 Rounds', discount: '30% off' },
  { id: 'pack100', units: 100, price: '$9.99', priceNum: 9.99, perUnit: '$0.10', label: '100 Rounds', discount: '50% off', popular: true },
  { id: 'pack500', units: 500, price: '$29.99', priceNum: 29.99, perUnit: '$0.06', label: '500 Rounds', discount: '70% off' },
  { id: 'pack1000', units: 1000, price: '$49.99', priceNum: 49.99, perUnit: '$0.05', label: '1000 Rounds', discount: '75% off', best: true }
];

const ICONS = ['🎯', '⭐', '🏆', '💎', '💎'];

export default function BuyUnitsModal({ onClose, currentBalance }) {
  const [loading, setLoading] = useState(null);

  const handlePurchase = async (packageId) => {
    setLoading(packageId);
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(apiUrl('/api/units/purchase'), {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ packageId })
      });
      const data = await res.json();
      console.log("Purchase response:", res.status, data);
      if (data.url) {
        window.location.href = data.url;
      } else {
        alert(data.error || 'Failed to start checkout');
      }
    } catch (e) {
      console.error('Payment error:', e);
      alert('Failed to connect to payment system: ' + e.message);
    }
    setLoading(null);
  };

  return (
    <div onClick={(e) => e.target === e.currentTarget && onClose()} style={{
      position: 'fixed',
      inset: 0,
      background: 'rgba(0,0,0,0.85)',
      backdropFilter: 'blur(8px)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000,
      padding: '20px'
    }}>
      <div style={{
        width: '100%',
        maxWidth: '500px',
        maxHeight: '90vh',
        overflow: 'auto',
        background: 'linear-gradient(135deg, #0d1525, #0a0f1c)',
        border: '1px solid rgba(255,255,255,0.1)',
        borderRadius: '24px',
        padding: '28px'
      }}>
        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '24px' }}>
          <div style={{ fontSize: '48px', marginBottom: '12px' }}>🪙</div>
          <h2 style={{ fontSize: '24px', fontWeight: '700', color: 'white', marginBottom: '8px' }}>
            Get More Units
          </h2>
          <p style={{ color: 'rgba(255,255,255,0.6)', fontSize: '14px' }}>
            Current balance: <span style={{ color: '#22c55e', fontWeight: '600' }}>{currentBalance} units</span>
          </p>
        </div>

        {/* Packages */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginBottom: '20px' }}>
          {PACKAGES.map((pkg, idx) => (
            <button
              key={pkg.id}
              onClick={() => handlePurchase(pkg.id)}
              disabled={loading}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '16px',
                padding: '16px 20px',
                background: pkg.popular ? 'rgba(102, 126, 234, 0.15)' : pkg.best ? 'rgba(34, 197, 94, 0.15)' : 'rgba(255,255,255,0.03)',
                border: pkg.popular ? '2px solid #667eea' : pkg.best ? '2px solid #22c55e' : '1px solid rgba(255,255,255,0.1)',
                borderRadius: '16px',
                cursor: loading ? 'wait' : 'pointer',
                position: 'relative',
                overflow: 'hidden'
              }}
            >
              {/* Badge */}
              {pkg.popular && (
                <div style={{
                  position: 'absolute',
                  top: '8px',
                  right: '12px',
                  background: '#667eea',
                  color: 'white',
                  fontSize: '10px',
                  fontWeight: '700',
                  padding: '3px 8px',
                  borderRadius: '6px',
                  textTransform: 'uppercase'
                }}>Popular</div>
              )}
              {pkg.best && (
                <div style={{
                  position: 'absolute',
                  top: '8px',
                  right: '12px',
                  background: '#22c55e',
                  color: 'white',
                  fontSize: '10px',
                  fontWeight: '700',
                  padding: '3px 8px',
                  borderRadius: '6px',
                  textTransform: 'uppercase'
                }}>Best Value</div>
              )}

              {/* Icon */}
              <div style={{
                width: '44px',
                height: '44px',
                borderRadius: '12px',
                background: 'rgba(255,255,255,0.1)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '22px'
              }}>
                {ICONS[idx]}
              </div>

              {/* Info */}
              <div style={{ flex: 1, textAlign: 'left' }}>
                <div style={{ color: 'white', fontWeight: '600', fontSize: '16px' }}>
                  {pkg.label}
                </div>
                <div style={{ color: 'rgba(255,255,255,0.5)', fontSize: '13px' }}>
                  {pkg.perUnit} per round
                  {pkg.discount && <span style={{ color: '#22c55e', marginLeft: '8px' }}>({pkg.discount})</span>}
                </div>
              </div>

              {/* Price */}
              <div style={{
                background: pkg.popular ? '#667eea' : pkg.best ? '#22c55e' : 'rgba(255,255,255,0.1)',
                color: 'white',
                padding: '10px 20px',
                borderRadius: '10px',
                fontWeight: '700',
                fontSize: '16px'
              }}>
                {loading === pkg.id ? '...' : pkg.price}
              </div>
            </button>
          ))}
        </div>

        {/* Info */}
        <div style={{
          background: 'rgba(255,255,255,0.03)',
          borderRadius: '12px',
          padding: '14px 18px',
          marginBottom: '16px'
        }}>
          <p style={{ color: 'rgba(255,255,255,0.6)', fontSize: '13px', textAlign: 'center', margin: 0 }}>
            💡 Each AI response costs <strong style={{ color: 'white' }}>1 unit</strong>. A full round with 4 AIs = 4 units.
          </p>
        </div>

        {/* Close */}
        <button
          onClick={onClose}
          style={{
            width: '100%',
            padding: '14px',
            background: 'rgba(255,255,255,0.05)',
            border: '1px solid rgba(255,255,255,0.1)',
            borderRadius: '12px',
            color: 'rgba(255,255,255,0.6)',
            fontSize: '15px',
            cursor: 'pointer'
          }}
        >
          Maybe Later
        </button>
      </div>
    </div>
  );
}
